export default "__VITE_ASSET__12a837a9__"